import { ListStateConstant } from '../actions/constants/ListStateConstant';

// IMP-307: stateKey 별 목록 화면 상태 스냅샷. F5/로그아웃 시 자연 소멸(persist 없음).
export const ListStateReducer = (state = {}, action) => {
    switch (action.type) {
        case ListStateConstant.SAVE:
            return { ...state, [action.stateKey]: { ...state[action.stateKey], ...action.snapshot } };
        case ListStateConstant.CLEAR: {
            const next = { ...state };
            delete next[action.stateKey];
            return next;
        }
        default:
            return state;
    }
};
